import {FormattedMessage, FormattedDate, FormattedTime, injectIntl, intlShape} from 'react-intl';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './css/Status.scss';

@injectIntl
export default class Status extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        order: PropTypes.any
    }

    render() {
        const {order} = this.props;

        if (!order.has('statusHistory')) {
            return null;
        }

        return (
            <div>
                <h3>
                    <FormattedMessage id='frontend.orders_detail.headline.history'/>
                </h3>
                <ul className={styles.list}>
                    {
                        order.get('statusHistory').map((status, i) => (
                            <li key={i} className={styles.item}>
                                <span className={styles.status}>
                                    <FormattedMessage id={status.get('status')}/>
                                </span>
                                <span>
                                    <FormattedDate day='2-digit' year='numeric' month='long' value={status.get('createdAt')}/>
                                    &nbsp;
                                    <FormattedTime value={status.get('createdAt')}/>
                                </span>
                            </li>
                        ))
                    }
                </ul>
            </div>
        );
    }
}
